import React, { useState, useEffect } from 'react';
import styles from '../../assets/styles/Homepage/Hero.module.css';

const ENV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
const API_BASE_URL = `${ENV_API_BASE_URL}`;

const Hero = () => {
  const [banners, setBanners] = useState([]);
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(true);

  // Fetch banners from backend
  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/banners`);
        const data = await res.json();

        if (data.success && data.data.length > 0) {
          setBanners(data.data);
        }
      } catch (err) {
        console.error('Error fetching banners:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  // Auto-slide effect
  useEffect(() => {
    if (banners.length === 0) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % banners.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [banners.length]);

  // Show loading state
  if (loading) {
    return (
      <section className={styles.hero}>
        <div className={styles.loadingState}>
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <p>Loading banners...</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Show message if no banners
  if (banners.length === 0) {
    return (
      <section className={styles.hero}>
        <div className={styles.noBanners}>
          <div className="container">
            <div className="row">
              <div className="col-12 text-center">
                <p>No banners available</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={styles.hero}>
      {/* Render all banners from backend with opacity transitions */}
      {banners.map((banner, index) => (
        <div
          key={banner._id}
          className={`${styles.bgImage} ${index === current ? styles.active : ''}`}
          style={{ backgroundImage: `url(${API_BASE_URL}${banner.image})` }}
        />
      ))}

      {/* Optional: Add banner indicators */}
      <div className={styles.indicators}>
        {banners.map((_, index) => (
          <button
            key={index}
            className={`${styles.indicator} ${index === current ? styles.activeIndicator : ''}`}
            onClick={() => setCurrent(index)}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </section>
  );
};

export default Hero;
